/**
 * Created by afane262 on 12/28/2015.
 */
window.I9EmployerForm = function($scope, $q, Upload, user, $state, isEverifyServiceEnabled, $modal, onBoardingService, uploadMode, documentsDefaultFieldsService, userPermissions) {

    var self = this;
    var formName = "i9-employer-form";
    var _protected = BaseForm.call(self, formName, $scope);

    self.attachmentIssuers = {};
    self.attachmentRules = {};
    self.docsDateValidation = {};
    self.warning = {};
    self.information = {};
    self.uploadMode = uploadMode;

    var _emitter = JarEventEmitter.call(self);

    self.documentTitles = OnBoardingAPI.DOCUMENT_CODES_TITLES;
    self.documentFullNames = OnBoardingAPI.DOCUMENT_CODES_FULL_NAMES;
    self.documentsImage = OnBoardingAPI.DOCUMENT_CODES_IMAGE_INFO;

    self.isEVerifyServiceEnabled = isEverifyServiceEnabled;

    self.canBeSentBack = true;

    self.first3DigitsWarning = false;
    self.middle2DigitsWarning = false;
    self.last4digitsWarning = false;

    self.passportsGeneralNames = {
        US_PASSPORT: "U.S. passport",
        US_PASSPORT_BACK: "U.S. passport back",
        US_PASSPORT_CARD: "U.S. passport card",
        US_PASSPORT_CARD_BACK: "U.S. passport back card",
    };

    self.DOCUMENT_CODES_TITLES = OnBoardingAPI.DOCUMENT_CODES_TITLES;
    self.ATTACHMENTS_CODES = {
        EMP_AUTH_DOC: "EMP_AUTH_DOC",
        PERM_RESID_CARD: "PERM_RESID_CARD"
    }

    self.onResendClick = function (type) {
        _emitter.trigger("resendDocumentClicked", type, self.docsDataToResend);
    };

    if (self.isEVerifyServiceEnabled) {

        var redirectLogic = function () {
            //redirect to previous state or to dashboard
            var goToState = 'appLayout.harriSH.dashboard';
            var goToStateParam = {};

            if (HStorageManager.get({
                key: 'review_docs_prev_state',
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            })) {
                var data = angular.copy(HStorageManager.get({
                    key: 'review_docs_prev_state',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                }));

                goToState = data.url;
                goToStateParam = data.params;

                if (goToState.toLowerCase() === 'appLayout.harriSH.ams') {
                    HStorageManager.remove({
                        key: 'review_docs_prev_state',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })
                }
            }

            $state.go(goToState, goToStateParam);
        };

        var promises = {};

        promises['check_exam_status'] = OnBoardingAPI.checkEVerifyExamStatus();

        $q.all(promises)
            .then(function (res) {
                if (res.check_exam_status !== 'PASSED') {
                    self.everifyModal = {};

                    self.everifyModal.data = {
                        brand: {
                            isDoneEVerifyTest: false
                        }
                    };

                    self.everifyModal.showEVerifyModal = true;

                    self.everifyModal.onClose =  function (res, code) {
                        switch (code) {
                            case 'REDIRECT_TO_TRAINING':
                                hRedirect("/training/e-verify/index");
                                break;

                            case 'NO_ACTION':
                                redirectLogic();
                        }
                    };
                }

                try {$scope.$digest();} catch (e) {}
            });
    }

    var events = {
        "esigned": [],
        "resendForm": []
    };

    self.onEsigned = function(handler) {
        events["esigned"].push(handler);
    };

    self.onResend = function(handler) {
        events["resendForm"].push(handler);
    };

    var trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    }

    self.minExpirationDate = moment().add(1, 'day').format('MMM DD, YYYY');

    self.dateValidation = function (docCode) {

        var restrict = {
            dateOnly: true,
            required: true,
            noDate: false,
            minExpirationDate: self.minExpirationDate
        };

        switch (docCode) {
            case "VOTER_REG_CARD":
            case 'PERM_RESID_CARD':
            case 'PERM_RESID_CARD_BACK':
                restrict.required = false;
                break;
            case "RECEIPT_I_94":
            case "FORM_I_94_A":
                restrict.dateOnly = false;
                break;

            case 'ALIEN_PERM_RESID_CARD':
                for (var i in self.data.userAttachments) {
                    if (self.data.userAttachments[i].old_resident_alien_cards) {
                        for (var key in self.validator.validation) {
                            if (key.indexOf("attachment-expiration-date") > -1) {
                                delete self.validator.validation[key];
                            }
                        }
                        restrict.required = false;
                    } else {
                        restrict.required = true;
                    }
                }
                break;
        }

        restrict.noDate = OnBoardingAPI.attachmentCodeLookup[docCode].expiration_date_mode === 'NOT_APPLICABLE';

        self.docsDateValidation[docCode] = restrict;
    };

    self.getRules = function (docCode) {
        var rules = {};

        switch (docCode) {
            case "US_PASSPORT_CARD":
            case "US_PASSPORT":
                rules.minlength = 6;
                rules.maxlength = 9;
                rules.rule = "alphanumeric|maxlength:" + rules.maxlength + "|minlength:" + rules.minlength;
                rules.placeholder = 'C00045894';
                break;
            case "FOREIGN_PASSPORT_TEMP_STAMP":
            case "FOREIGN_PASSPORT_TEMP_MRIV":
            case "FOREIGN_PASSPORT":
            case "FSM_PASSPORT":
            case "RIM_PASSPORT":
                rules.minlength = 6;
                rules.maxlength = 12;
                rules.rule = "alphanumeric|maxlength:" + rules.maxlength + "|minlength:" + rules.minlength;
                rules.placeholder = 'G123456';
                break;
            case "FORM_I_94_A":
            case "RECEIPT_FORM_I_94_A":
            case "RECEIPT_I_94":
            case "RECEIPT_I_94_REFUGEE":
                rules['exact-length'] = 11;
                rules.pattern="^[0-9]{9}[0-9a-zA-Z]{1}[0-9]{1}$";
                break;
            case "PERM_RESID_CARD":
                rules.mask = "@@@9999999999";
                rules.pattern="^[a-zA-Z]{3}[0-9]{9,10}$";
                rules.placeholder = 'SRC0000000725';
                break;
            case "ALIEN_PERM_RESID_CARD":
            case "EMP_AUTH_DOC":
                rules.mask = "@@@9999999999";
                rules.pattern="^[A-Z]{3}\\d{10}$";
                rules.placeholder = 'MSC0902850001';
                break;
            case "DRIVER_LICENSE":
            case "ID_CARD_BY_STATE":
                rules.minlength = 1;
                rules.maxlength = 25;
                rules.rule = "alphanumeric|maxlength:" + rules.maxlength + "|minlength:" + rules.minlength;
                rules.placeholder = '1234b56789';
                break;
            case "FORM_I_20":
            case "FORM_DS_2019":
                rules['exact-length'] = 11;
                rules.pattern="^N\\d{10}$";
                rules.mask = "N9999999999";
                rules.placeholder = 'N0000000001';
                break;
            default:
                rules.rule = "alphanumeric";
        }
        self.attachmentRules[docCode] = rules;
    };

    if (self.isEVerifyServiceEnabled) {
        events['startEVerify'] = [];

        self.onEVerifyStart = function (handler) {
            events['startEVerify'].push(handler);
        };

        self.startEVerify = function (withoutSaveRes) {

            var startEVerify = function (res) {
                self.everifyModal = {};

                setTimeout(function () {
                    self.everifyModal.showEVerifyModal = true;

                    self.OBIdObj.brand = self.OBIdObj.brand || {};

                    self.OBIdObj.brand.isDoneEVerifyTest = true;

                    self.everifyModal.data = {
                        job: self.OBIdObj.job,
                        brand: self.OBIdObj.brand,
                        everify_case: {
                            id: res.e_verify_case_id
                        },
                        user: self.OBIdObj.user,
                        application_id: self.OBIdObj.document.application_id,
                        prospect_id: self.OBIdObj.document.prospect_id
                    };

                    self.everifyModal.onClose =  function (res, code) {

                        switch (code) {
                            case 'REDIRECT_TO_TRAINING':
                                hRedirect("/training/e-verify/index");
                                break;

                            case 'RESEND_I9':
                                trigger("resendForm", res, code);
                                break;

                            default:
                                trigger("esigned",  res);
                        }
                    };

                    $scope.$digest();
                }, 100);
            };

            if (withoutSaveRes) {
                startEVerify(withoutSaveRes);
            } else {
                self.save(null, true)
                    .then(function (res) {
                        startEVerify(res);
                    });
            }
        };
    }

    //data
    self.OBIdObj = null;
    self.data = {};

    self.states = US_STATES;

    self.saving = false;
    self.selectedFiles = {};

    //some form data
    self.data.userAttachments = [];
    self.listType = 'LIST_A';

    var initListDocs = function () {
        self.listDocs = {
            'A': [],
            'A_SECOND': [],
            'A_THIRD': [],
            'B': [],
            'C': []
        };
    };
    initListDocs();

    var LIST_A_DOCUMENTS_CITIZENSHIP = {
        US_CITIZEN: [
            "US_PASSPORT",
            "US_PASSPORT_CARD"
        ],
        NON_CITIZEN: [
            "US_PASSPORT",
            "US_PASSPORT_CARD"
        ],
        PERMENANT: [
            "PERM_RESID_CARD",
            "ALIEN_PERM_RESID_CARD",
            "FOREIGN_PASSPORT_TEMP_STAMP",
            "FOREIGN_PASSPORT_TEMP_MRIV",
            "RECEIPT_I_94",
            "RECEIPT_PERM_RESID_CARD",
        ],
        ALIEN_AUTH: [
            "EMP_AUTH_DOC",
            "FOREIGN_PASSPORT",
            "RIM_PASSPORT",
            "FSM_PASSPORT",
            "RECEIPT_REPLACEMENT_EAD",
            "RECEIPT_I_94_REFUGEE",
            "RECEIPT_FOREIGN_PASSPORT",
            "RECEIPT_FSM_PASSPORT",
            "RECEIPT_RIM_PASSPORT"
        ]
    };

    var LIST_B = [
        "DRIVER_LICENSE",
        "ID_CARD_BY_STATE",
        "GOVERMENT_ID",
        "SCHOOL_ID",
        "MILITARY_DEP_ID",
        "USCG_MERCH_MARINER_CARD",
        "CANADIAN_DRIVER_LICENSE",
        "SPECIAL_PLACEMENT",
        "RECEIPT_DRIVER_LICENSE",
        "RECEIPT_ID_CARD_BY_STATE",
        "RECEIPT_GOVERMENT_ID",
        "RECEIPT_SCHOOL_ID",
        "RECEIPT_VOTER_REG_CARD",
        "RECEIPT_US_MILITARY_CARD",
        "RECEIPT_US_MILITARY_DRAFT",
        "RECEIPT_MILITARY_DEP_ID",
        "RECEIPT_USCG_MERCH_MARINER_CARD",
        "RECEIPT_NATIVE_AMERICAN_TRIPLE_DOC",
        "RECEIPT_CANADIAN_DRIVER_LICENSE",
        "SCHOOL_RECORD_UND_18",
        "REPORT_CARD_UND_18",
        "CLINIC_RECORD_UND_18",
        "DOCTOR_RECORD_UND_18",
        "HOSPITAL_RECORD_UND_18",
        "DAY_CARE_RECORD_UND_18",
        "NURSERY_SCHOOL_RECORD_UND_18"
    ];

    var LIST_C_DOCUMENTS_CITIZENSHIP = {
        US_CITIZEN: [
            "SOCIAL_SECURITY_CARD_UNRESTRICTED",
            "FORM_FS_545",
            "FORM_DS_1350",
            "US_BRITH_CERTIFICATE",
            "CONSULAR_REPORT_OF_BIRTH_ABROAD",
            "FORM_I_197",
            "FORM_I_179",
            "EMPLOYMENT_AUTH_DHS",
            "RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE",
            "RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL",
            "RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD",
            "RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS"
        ],
        NON_CITIZEN: [
            "SOCIAL_SECURITY_CARD_UNRESTRICTED",
            "CONSULAR_REPORT_OF_BIRTH_ABROAD",
            "FORM_FS_545",
            "FORM_DS_1350",
            "US_BRITH_CERTIFICATE",
            "FORM_I_197",
            "FORM_I_179",
            "EMPLOYMENT_AUTH_DHS",
            "RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE",
            "RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL",
            "RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD",
            "RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS",
        ],
        PERMENANT: [
            "SOCIAL_SECURITY_CARD_UNRESTRICTED",
            "EMPLOYMENT_AUTH_DHS",
            "RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL",
            "RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD",
            "RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS"
        ],
        ALIEN_AUTH: [
            "SOCIAL_SECURITY_CARD_UNRESTRICTED",
            "EMPLOYMENT_AUTH_DHS",
            "RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL",
            "RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD",
            "RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS"
        ]
    };

    if (!self.isEVerifyServiceEnabled || true) {
        LIST_B = LIST_B.concat(["US_MILITARY_DRAFT", "VOTER_REG_CARD", "NATIVE_AMERICAN_TRIPLE_DOC", "US_MILITARY_CARD"]);
        for (var i in LIST_C_DOCUMENTS_CITIZENSHIP) {
            LIST_C_DOCUMENTS_CITIZENSHIP[i].push("NATIVE_AMERICAN_TRIPLE_DOC");
        }
    }

    self.NA_FIELDS = [
        "Special Placement",
        "SCHOOL_RECORD_UND_18",
        "REPORT_CARD_UND_18",
        "CLINIC_RECORD_UND_18",
        "DOCTOR_RECORD_UND_18",
        "HOSPITAL_RECORD_UND_18",
        "DAY_CARE_RECORD_UND_18",
        "NURSERY_SCHOOL_RECORD_UND_18"
    ];

    var A_OTHER_ATTACHMENT = {
        "FOREIGN_PASSPORT_TEMP_STAMP": {
            "SECOND_ATTACHMENT": ["TEMP_I_551_STAMP"],
            "THIRD_ATTACHMENT": []
        },
        "FOREIGN_PASSPORT_TEMP_MRIV": {
            "SECOND_ATTACHMENT": ["MACHINE_READABLE_IMMIGRANT_VISA"],
            "THIRD_ATTACHMENT": []
        },
        "FOREIGN_PASSPORT": {
            "SECOND_ATTACHMENT": ["FORM_I_94_A", "RECEIPT_FORM_I_94_A"],
            "THIRD_ATTACHMENT": ["N/A", "FORM_I_20", "FORM_DS_2019"]
        },
        "RIM_PASSPORT": {
            "SECOND_ATTACHMENT": ["FORM_I_94_A", "RECEIPT_FORM_I_94_A"],
            "THIRD_ATTACHMENT": []
        },
        "RECEIPT_FOREIGN_PASSPORT": {
            "SECOND_ATTACHMENT": ["FORM_I_94_A", "RECEIPT_FORM_I_94_A"],
            "THIRD_ATTACHMENT": ["N/A", "FORM_I_20", "FORM_DS_2019"]
        },
        "RECEIPT_FSM_PASSPORT": {
            "SECOND_ATTACHMENT": ["FORM_I_94_A", "RECEIPT_FORM_I_94_A"],
            "THIRD_ATTACHMENT": ["N/A", "FORM_I_20", "FORM_DS_2019"]
        },
        "RECEIPT_RIM_PASSPORT": {
            "SECOND_ATTACHMENT": ["FORM_I_94_A", "RECEIPT_FORM_I_94_A"],
            "THIRD_ATTACHMENT": ["N/A", "FORM_I_20", "FORM_DS_2019"]
        }
    };

    var BACK_CARD_ATTACHMENTS = {
        'EMP_AUTH_DOC_BACK': {
            front_code: 'EMP_AUTH_DOC'
        },
        'US_PASSPORT_BACK': {
            front_code: 'US_PASSPORT'
        },
        'US_PASSPORT_CARD_BACK': {
            front_code: 'US_PASSPORT_CARD'
        },
        'PERM_RESID_CARD_BACK': {
            front_code: 'PERM_RESID_CARD'
        }
    };

    var addListDocsB = function () {
        for (var i in LIST_B) {
            self.listDocs['B'].push(LIST_B[i]);
        }
    }
    addListDocsB();

    self.showBackCardUpload = function (attachmentCode) {
        return (
            attachmentCode === 'EMP_AUTH_DOC' ||
            attachmentCode === 'US_PASSPORT' ||
            attachmentCode === 'US_PASSPORT_CARD' ||
            attachmentCode === 'PERM_RESID_CARD'
        );
    };

    var getBackCardCode = function (frontCode) {

        switch (frontCode) {
            case 'EMP_AUTH_DOC':
                return 'EMP_AUTH_DOC_BACK';
            case 'US_PASSPORT':
                return 'US_PASSPORT_BACK';
            case 'US_PASSPORT_CARD':
                return 'US_PASSPORT_CARD_BACK';
            case 'PERM_RESID_CARD':
                return 'PERM_RESID_CARD_BACK';
            default:
                return '';
        }
    };

    self.changeExpireDateType = function () {

        for (var i in self.data.userAttachments) {

            if (self.data.userAttachments[i].date_as_text &&
                self.data.userAttachments[i].expiration_date) {
                var date = moment(self.data.userAttachments[i].expiration_date, "MMMM DD, YYYY", true);
                if (date.isValid()) {
                    self.data.userAttachments[i].expiration_date = date.format("MMMM DD, YYYY");
                }
            }
        }

        $scope.$digest();
    };

    self.changeIssuingAuth = function (attachment) {

        var issuing = _.find(self.attachmentIssuers[attachment.code], function (issue) {
            return issue.Code === attachment.issuing_authority;
        });
        attachment.issuing_authority_name = issuing && issuing.Name;
    };

    self.attachmentExpirationDateChanged = function (attachmentExpirationDate, attachmentCode, index) {
        self.warning['attachment-expiration-date'] = self.warning['attachment-expiration-date'] || {};
        self.warning['attachment-expiration-date'][index] = self.warning['attachment-expiration-date'][index] || {};
        self.information['attachment-expiration-date'] = self.information['attachment-expiration-date'] || {};
        self.information['attachment-expiration-date'][index] = self.information['attachment-expiration-date'][index] || {};
        if (attachmentExpirationDate) {
            switch (attachmentCode) {
                case 'DRIVER_LICENSE':
                case 'ID_CARD_BY_STATE':
                    if (!moment(attachmentExpirationDate).startOf('day').isBefore(moment(self.docsDateValidation[attachmentCode].minExpirationDate).startOf('day')) &&
                        !moment(attachmentExpirationDate).startOf('day').isAfter(moment().startOf('day'))) {
                        self.warning['attachment-expiration-date'][index]['covidExtension'] = 'Expired ' + OnBoardingAPI.DOCUMENT_CODES_TITLES[attachmentCode] + ' is only applicable due to COVID-19 Pandemic.';
                        self.information['attachment-expiration-date'][index]['covidExtension'] = 'If the state has announced an extension please fill in “COVID-19 ext” in the additional section, if the state has not announced an extension please fill “COVID-19”  in the additional information section.';
                    } else {
                        delete self.warning['attachment-expiration-date'][index]['covidExtension'];
                        delete self.information['attachment-expiration-date'][index]['covidExtension'];
                    }
                    break;
                default:
                    delete self.warning['attachment-expiration-date'][index]['covidExtension'];
                    delete self.information['attachment-expiration-date'][index]['covidExtension'];
                    break;
            }
        }
    };

    self.clearFieldNotes = function (fieldName, type, noteName, index) {
        var clearNotes = function (notes) {
            if (notes[fieldName]) {
                if (notes[fieldName][index]) {
                    delete notes[fieldName][index][noteName];
                } else {
                    for (var i in notes[fieldName]) {
                        delete notes[fieldName][i];
                    }
                }
            }
        }

        if (type === 'warning') {
            clearNotes(self.warning);
        } else if (type === 'information') {
            clearNotes(self.information);
        } else if (type === 'all') {
            clearNotes(self.warning);
            clearNotes(self.information);
        }
    };

    self.isExpirationDateOptional = function (attachment) {

        return (
            (attachment.issuing_authority == 'AZ' && attachment.code == "ID_CARD_BY_STATE") ||
            attachment.code == "FORM_I_197" ||
            attachment.code == "HOSPITAL_RECORD_UND_18" ||
            attachment.code == "DRIVER_LICENSE" ||
            attachment.code == "ID_CARD_BY_STATE"
        );
    };

    self.hasNoExpirationDateHandler = function (attachment) {

        if (attachment.has_no_expiration_date) {
            attachment.expiration_date = null;
        }
    };

    self.onDocumentChange = function (attachment, index) {

        attachment.title = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];
        attachment.custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];
        attachment.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];

        if (attachment.code && self.listType == "LIST_B_AND_C") {
            attachment.expiration_date = '';
            attachment.date_as_text = false;
            delete self.validator.validation['attachment-expiration-date' + index];
        }

        if (self.selectedFiles[attachment.list_type]) {
            self.selectedFiles[attachment.list_type] = self.selectedFiles[attachment.list_type] || {};
            self.selectedFiles[attachment.list_type].code = attachment.code;
            self.selectedFiles[attachment.list_type].title = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];
            self.selectedFiles[attachment.list_type].name = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];
            self.selectedFiles[attachment.list_type].custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];
        }


        if (self.showBackCardUpload(attachment.code)) {
            self.backCardAttachments = self.backCardAttachments || {attachment: {}, selectedFile: {}}

            var backCardCode = getBackCardCode(attachment.code);
            var backCardTitle = OnBoardingAPI.DOCUMENT_CODES_TITLES[backCardCode];
            self.backCardAttachments.attachment.code = backCardCode;
            self.backCardAttachments.attachment.list_type = attachment.list_type;
            self.backCardAttachments.attachment.title = backCardTitle;
            self.backCardAttachments.attachment.custom_name = backCardTitle;
            self.backCardAttachments.attachment.name = backCardTitle;

            if (self.backCardAttachments &&
                self.backCardAttachments.selectedFile &&
                (self.backCardAttachments.selectedFile.id || self.backCardAttachments.selectedFile.file)
            ) {
                self.backCardAttachments.selectedFile.code = backCardCode;
                self.backCardAttachments.selectedFile.title = backCardTitle;
                self.backCardAttachments.selectedFile.custom_name = backCardTitle;
                self.backCardAttachments.selectedFile.name = backCardTitle;
            }

        }

        self.changeDocType(attachment.list_type, attachment.code);
        self.getIssuingAuth(attachment.code);
        self.getRules(attachment.code);
        self.dateValidation(attachment.code);

        delete attachment.has_no_expiration_date;
        self.checkDocNumberLength(attachment);
        self.attachmentExpirationDateChanged(attachment.expiration_date, attachment.code, index);
    };

    self.showMoreInfoMessage = function () {
        hAlert({
            title: "Social Security Card (Unrestricted)",
            text: $filter("translate")("Only unrestricted Social Security Cards are acceptable for Form I-9. If the card has one of the following restrictions, you should ask the employee to provide a different document showing work authorization") + ':<br><br>' +
                '<ul><li>' + $filter("translate")("NOT VALID FOR EMPLOYMENT") +
                '</li><li>' + $filter("translate")("VALID FOR WORK ONLY WITH INS AUTHORIZATION") +
                '</li><li>' + $filter("translate")("VALID FOR WORK ONLY WITH DHS AUTHORIZATION") + '</li></ul>',
            custom_class: 'rejection-templates-error-alert',
            button: {
                text: $filter("translate")("Okay")
            }
        });
    };

    self.changeOldResidentAlienCards = function () {
        for (var i in self.data.userAttachments) {
            var attachment = self.data.userAttachments[i];

            if (attachment.old_resident_alien_cards) {
                attachment.expiration_date = '';
                attachment.number = 'AAA0000000000';
            } else {
                attachment.number = '';
            }

            self.dateValidation(attachment.code)
        }
    };

    self.showReceiptRule = function () {

        $modal({
            controller: 'ReceiptRulesModalController',
            controllerAs: 'ReceiptRulesModal',
            templateUrl: '../hmodules/on-boarding/modals/receipt-rules/receipt-rules.modal.html',
            show: true
        });
    };

    self.changeDocType = function  (list, code) {

        if (list == "A_THIRD") {
            for (var i = 0; i < self.data.userAttachments.length; i++) {
                if (self.data.userAttachments[i].list_type == 'A_THIRD') {

                    if (code == "N/A") {
                        self.data.userAttachments[i] = {
                            list_type: "A_THIRD",
                            title: "N/A",
                            name: "N/A",
                            code: "N/A",
                            custom_name: "N/A"
                        };

                        delete self.selectedFiles['A_THIRD'];
                    } else {
                        var aThirdDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A_THIRD') || {};
                        aThirdDocumentList.title = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
                        aThirdDocumentList.code = code;
                        aThirdDocumentList.number = "";
                        aThirdDocumentList.issuing_authority = "";
                        aThirdDocumentList.issuing_authority_name = "";
                        aThirdDocumentList.expiration_date = null;
                        aThirdDocumentList.list_type = "A_THIRD";
                        aThirdDocumentList.custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
                        aThirdDocumentList.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];

                        self.selectedFiles['A_THIRD'] = self.selectedFiles['A_THIRD'] || {};
                        self.selectedFiles['A_THIRD'].code = code;
                        self.selectedFiles['A_THIRD'].name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
                        self.selectedFiles['A_THIRD'].custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
                        self.selectedFiles['A_THIRD'].title = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];

                        self.data.userAttachments[i] = aThirdDocumentList;
                    }

                    break;
                }
            }
        }

        if (list == 'A_SECOND') {
            self.selectedFiles['A_SECOND'] = self.selectedFiles['A_SECOND'] || {};
            self.selectedFiles['A_SECOND'].code = code;
            self.selectedFiles['A_SECOND'].name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
            self.selectedFiles['A_SECOND'].custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
            self.selectedFiles['A_SECOND'].title = OnBoardingAPI.DOCUMENT_CODES_TITLES[code];
        }

        if (list == 'A') {

            var changeDocTypeA = function (newCode) {

                for (var i = self.data.userAttachments.length -1; i >= 0 ; i--) {
                    if (!BACK_CARD_ATTACHMENTS[self.data.userAttachments[i].code]) {
                        if (self.data.userAttachments[i].list_type == 'A') {
                            self.data.userAttachments[i].title = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            self.data.userAttachments[i].name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            self.data.userAttachments[i].custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                        }

                        if(self.data.userAttachments[i].list_type == 'A_SECOND' ||
                            self.data.userAttachments[i].list_type == 'A_THIRD'){
                            var index = self.data.userAttachments.indexOf(self.data.userAttachments[i]);

                            self.data.userAttachments.splice(index, 1);
                        }
                    }
                }

                if (A_OTHER_ATTACHMENT[newCode]) {

                    if (A_OTHER_ATTACHMENT[newCode].SECOND_ATTACHMENT.length) {
                        self.listDocs['A_SECOND'] = A_OTHER_ATTACHMENT[newCode].SECOND_ATTACHMENT;

                        var aSecondDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A_SECOND') || {};

                        var secondADocs = {'list_type': 'A_SECOND'};

                        var hasSecondAttachment = _.find(A_OTHER_ATTACHMENT[newCode].SECOND_ATTACHMENT, function(element) {
                            return aSecondDocumentList.code == element;
                        });

                        if (hasSecondAttachment) {
                            $.extend(secondADocs, aSecondDocumentList);

                            secondADocs.code = newCode;
                            secondADocs.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            secondADocs.custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            secondADocs.title = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                        }

                        self.data.userAttachments.push(secondADocs);
                    } else {
                        delete self.selectedFiles['A_SECOND'];
                    }

                    if (A_OTHER_ATTACHMENT[newCode].THIRD_ATTACHMENT.length) {
                        self.listDocs['A_THIRD'] = A_OTHER_ATTACHMENT[newCode].THIRD_ATTACHMENT;

                        var aThirdDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A_THIRD') || {};

                        var thirdDocs = {'list_type': 'A_THIRD'};

                        var hasThirdAttachment = _.find(A_OTHER_ATTACHMENT[newCode].THIRD_ATTACHMENT, function(element) {
                            return aThirdDocumentList.code == element.code;
                        });

                        if (hasThirdAttachment) {
                            $.extend(thirdDocs, aThirdDocumentList);

                            thirdDocs.code = newCode;
                            thirdDocs.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            thirdDocs.custom_name = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                            thirdDocs.title = OnBoardingAPI.DOCUMENT_CODES_TITLES[newCode];
                        }

                        self.data.userAttachments.push(thirdDocs);
                    } else {
                        delete self.selectedFiles['A_THIRD'];
                    }
                } else {
                    delete self.selectedFiles['A_THIRD'];
                    delete self.selectedFiles['A_SECOND'];
                }
            };

            changeDocTypeA(code);
        }
    };

    self.changeDocumentList = function (list) {
        self.clearFieldNotes('attachment-expiration-date', 'all','covidExtension');
        self.data.userAttachments = [];

        if (list == 'A') {
            delete self.selectedFiles['A_THIRD'];
            delete self.selectedFiles['A_SECOND'];
            delete self.selectedFiles['A'];

            var bDocumentList = findAttachment(self.OBIdObj.document.attachments, 'B') || {};
            bDocumentList.list_type = 'B';

            var cDocumentList = findAttachment(self.OBIdObj.document.attachments, 'C') || {};
            cDocumentList.list_type = 'C';

            self.data.userAttachments = [
                bDocumentList,
                cDocumentList
            ];

            if (Object.keys(bDocumentList).length > 1) {
                self.selectedFiles['B'] = angular.copy(bDocumentList);
            }

            if (Object.keys(cDocumentList).length > 1) {
                self.selectedFiles['C'] = angular.copy(cDocumentList);
            }

            if (!BACK_CARD_ATTACHMENTS[bDocumentList.code]) {
                self.getIssuingAuth(bDocumentList.code);
            }

            if (!BACK_CARD_ATTACHMENTS[cDocumentList.code]) {
                self.getIssuingAuth(cDocumentList.code);
            }

        } else {
            delete self.selectedFiles['C'];
            delete self.selectedFiles['B'];

            var aDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A') || {};
            aDocumentList.list_type = 'A';

            self.data.userAttachments = [
                aDocumentList
            ];

            if (Object.keys(aDocumentList).length > 1) {
                self.selectedFiles['A'] = angular.copy(aDocumentList);
            }

            if (!BACK_CARD_ATTACHMENTS[aDocumentList.code]) {
                self.getIssuingAuth(aDocumentList.code);
            }

            if (!_.isEmpty(aDocumentList)) {
                var aSecondDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A_SECOND') || {};
                var aThirdDocumentList = findAttachment(self.OBIdObj.document.attachments, 'A_THIRD') || {};

                var thereIsSecondDocs = false;

                if (!_.isEmpty(aSecondDocumentList)) {
                    aSecondDocumentList.list_type = 'A_SECOND';
                    self.data.userAttachments.push(aSecondDocumentList);
                    thereIsSecondDocs = true;

                    if (Object.keys(aSecondDocumentList).length > 1) {
                        self.selectedFiles['A_SECOND'] = angular.copy(aSecondDocumentList);
                    }
                }

                if (thereIsSecondDocs) {
                    if (_.isEmpty(aThirdDocumentList)) {
                        aThirdDocumentList.title = "N/A";
                    }

                    aThirdDocumentList.list_type = 'A_THIRD';
                    self.data.userAttachments.push(aThirdDocumentList);

                    if (Object.keys(aThirdDocumentList).length > 1 && (aThirdDocumentList.title !== "N/A")) {
                        self.selectedFiles['A_THIRD'] = angular.copy(aThirdDocumentList);
                    }
                }
            }
        }

        for (var key in self.validator.validation) {
            if (key.indexOf("attachment") > -1) {
                delete self.validator.validation[key];
            }
        }
    };

    self.load = function (OBIdObj) {
        var defer = $q.defer();

        var prePromises = {
            'onBoardingDocs': onBoardingService.listDocuments(OBIdObj.document.application_id, OBIdObj.document.prospect_id),
            'resendDocsData': onBoardingService.getNeededDataForDocResend(OBIdObj)
        };
        if (OBIdObj.job.Position) {
            var positionCode = OBIdObj.job.Position.code || (OBIdObj.job.Position.position && OBIdObj.job.Position.position.code);
            var positionTypeCode = (OBIdObj.job.Position.position_type && OBIdObj.job.Position.position_type.code) || (OBIdObj.job.Position.position && OBIdObj.job.Position.position.position_type && OBIdObj.job.Position.position.position_type.code);
        }

        if (isEverifyServiceEnabled) {
            prePromises['policyParser'] = userPermissions.getBrandPolicy(OBIdObj.brand.id);
            prePromises['everifyHiringRestrictions'] = EVerifyAPI.getEverifyHiringRestrictions(OBIdObj.brand.id, OBIdObj.user.id, positionCode)
        }

        $q.all(prePromises)
            .then(function (res) {
                var stateWithholdingCode = onBoardingService.getStateWithholdingCode(res['onBoardingDocs']);
                var docs = res['onBoardingDocs'];
                var userInfo = res['resendDocsData'].userDetails;
                var updatedOBIdObj = res['resendDocsData'].updatedOBIdObj;

                if (isEverifyServiceEnabled) {
                    var canHireOpenEVerifyCases = res.policyParser.position(positionTypeCode, positionCode).has(userPermissions.PERMISSIONS.HIRE_CANDIDATES_WITH_OPEN_E_VERIFY_CASES);
                    var everifyHiringRestrictions = res['everifyHiringRestrictions'];
                    if (!canHireOpenEVerifyCases && [EVerifyAPI.EVERIFY_HIRING_RESTRICTION.AFTER_OPENING_CASE, EVerifyAPI.EVERIFY_HIRING_RESTRICTION.AUTHORIZED_ONLY, EVerifyAPI.EVERIFY_HIRING_RESTRICTION.CLOSED_ONLY].indexOf(everifyHiringRestrictions.mode) > -1) {
                        self.hideEverifyAction = true;
                    }
                }
                var promises = {
                    'attachmentCodeLookup': OnBoardingAPI.getAttachmentCodeLookup(),
                    'onBoardingSettings': onBoardingService.getOnboardingBrandSettings(OBIdObj.brand.id),
                    'mismatchFields': onBoardingService.checkMismatchFields(OBIdObj.brand.id, OBIdObj.document.prospect_id, OBIdObj.document.application_id, stateWithholdingCode)
                };

                $q.all(promises)
                    .then(function (res) {
                        self.employerPreFillingEnabled = res['onBoardingSettings'].i9_employer_pre_filling_enabled;
                        self.mismatchfields = res.mismatchFields.mismatch_fields_list;
                        self.hasUserProfileMismatch = res.mismatchFields.userMismatch;
                        self.hasW4OrStateWithholdingMismatch = res.mismatchFields.w4OrStateWithholdingMismatch;
                        self.w4Signed = res.mismatchFields.w4Signed;
                        self.stateWithholdingSigned = res.mismatchFields.stateWithholdingSigned;
                        self.mismatchfieldsNames = res.mismatchFields.mismatchFieldsNames;
                        self.mismatchFieldsDetails = res.mismatchFields.mismatch_fields_details;

                        var w4Doc;
                        var stateWithholdingDoc;
                        var offerMetadata;

                        for (var i in docs) {
                            if (docs[i].code === OnBoardingAPI.DOCUMENT_TYPE.W4 && docs[i].Document) {
                                w4Doc = docs[i];
                            }

                            if (docs[i].code === stateWithholdingCode && docs[i].Document && docs[i].Document.state == "SIGNED") {
                                stateWithholdingDoc = docs[i];
                            }

                            if (docs[i].code === OnBoardingAPI.DOCUMENT_TYPE.OFFER && docs[i].Document) {
                                offerMetadata = docs[i].Document.meta_data;
                            }
                        }

                        self.docsToSend = [];
                        self.docsDataToResend = {};
                        if (self.w4Signed || self.stateWithholdingSigned) {
                            if (w4Doc) {
                                self.docsToSend.push(w4Doc);
                            }
                            if (stateWithholdingDoc) {
                                self.docsToSend.push(stateWithholdingDoc);
                            }

                            self.docsDataToResend = {
                                OBIdObj: updatedOBIdObj,
                                userInfo: userInfo,
                                offerMetadata: offerMetadata,
                                docsToSend: self.docsToSend,
                                hasW4:  self.w4Signed,
                                hasStateWithholding: self.stateWithholdingSigned
                            }
                        }

                        self.prepareFormData(OBIdObj);
                        defer.resolve();
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    })
            })
            .catch(function (err) {
                console.error(err);
            });
        return defer.promise;
    };

    self.checkDocNumberLength = function (attachment) {
        if (attachment.code == 'DRIVER_LICENSE') {
            self.showDocNumberLengthWarning = attachment.number && attachment.number.length > 17;
        } else {
            delete self.showDocNumberLengthWarning;
        }
    };

    var userCurrentPositionCached;
    var getUserCurrentPositionWithCache = function (userId) {
        var defer = $q.defer();
        if (userCurrentPositionCached) {
            defer.resolve(userCurrentPositionCached);
        } else {
            UserAPI.getUserCurrentPosition(userId)
                .then(function (res) {
                    userCurrentPositionCached = res;
                    defer.resolve(res);
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                })
        }
        return defer.promise;
    };

    var lastDocMetaCached;
    var getLastDocMetaWithCache = function (docType, docSetCode, brandId) {
        var defer = $q.defer();

        if (lastDocMetaCached) {
            defer.resolve(lastDocMetaCached);
        } else {
            OnBoardingAPI.getLastDocMeta(docType, docSetCode, brandId)
                .then(function (res) {
                    lastDocMetaCached = res;
                    defer.resolve(res);
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                })
        }

        return defer.promise;
    };


    //load object into the form
    self.prepareFormData = function (OBIdObj) {

        if(OBIdObj){
            self.OBIdObj = OBIdObj;
            initListDocs();
            addListDocsB();

            var brandLocation = self.OBIdObj.brand.location || {};

            //Autofill data
            self.data = {};

            self.data.business_name = self.OBIdObj.brand.name;
            self.data.business_address = {
                city: brandLocation.city && self.OBIdObj.brand.location.city.name,
                state: brandLocation.state && self.OBIdObj.brand.location.state.name,
                zip_code: brandLocation.postal_code
            };
            self.data.business_address.state = convertBetweenStateAndAbbreviation(self.data.business_address.state, true);

            if (self.employerPreFillingEnabled) {
                self.data.employer_first_name = user.data.user.first_name;
                self.data.employer_last_name = user.data.user.last_name;
            }

            var EMPLOYEE_CITIZENSHIP = self.OBIdObj.document && self.OBIdObj.document.meta_data && self.OBIdObj.document.meta_data.citizenship;

            var _A_CITIZENSHIP = LIST_A_DOCUMENTS_CITIZENSHIP[EMPLOYEE_CITIZENSHIP];

            for (var j in _A_CITIZENSHIP) {
                self.listDocs['A'].push(_A_CITIZENSHIP[j]);
            }

            var _C_CITIZENSHIP = LIST_C_DOCUMENTS_CITIZENSHIP[EMPLOYEE_CITIZENSHIP];

            for (var j in _C_CITIZENSHIP) {
                self.listDocs['C'].push(_C_CITIZENSHIP[j]);
            }

            //Fill attachments
            self.excludeAttachment = self.OBIdObj.document.exclude_attachments;

            if (self.OBIdObj.document && self.OBIdObj.document.attachments && self.OBIdObj.document.attachments.length){

                self.data.userAttachments = [];

                var LIST_A_CODE;

                for (var i in self.OBIdObj.document.attachments) {
                    var attachment = self.OBIdObj.document.attachments[i];

                    if (attachment.attachment_code_lookup) {
                        attachment.attachment_code_lookup.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.attachment_code_lookup.code] || attachment.custom_name;
                    } else {
                        attachment.attachment_code_lookup = {
                            name: attachment.custom_name,
                            code: ''
                        };
                    }

                    attachment.code = attachment.attachment_code_lookup.code;
                    attachment.name = attachment.attachment_code_lookup.name;

                    if (attachment.list_type === 'A') {
                        if (BACK_CARD_ATTACHMENTS[attachment.code]) {
                            self.backCardAttachments = {
                                selectedFile: {
                                    id: attachment.id,
                                    name: attachment.name,
                                    code: attachment.code,
                                    title: attachment.name,
                                    custom_name: attachment.name
                                },
                                attachment: attachment
                            };

                        } else {
                            LIST_A_CODE = attachment.code;
                        }
                    }
                }

                var isThereSecondA = false;
                var isThereThirdA = false;

                for (var i in self.OBIdObj.document.attachments) {
                    var attachment = angular.copy(self.OBIdObj.document.attachments[i]);

                    self.getRules(attachment.code);
                    self.dateValidation(attachment.code);
                    attachment.title = OnBoardingAPI.DOCUMENT_CODES_TITLES[attachment.code];

                    if (attachment.list_type === 'A') {
                        self.listType = 'LIST_A';

                        if (['PERM_RESID_CARD', 'PERM_RESID_CARD_BACK', 'ALIEN_PERM_RESID_CARD'].indexOf(attachment.code) > -1) {
                            attachment.old_resident_alien_cards = false;
                        }

                        if (!BACK_CARD_ATTACHMENTS[attachment.code]) {
                            self.data.userAttachments.push(attachment);
                            self.selectedFiles['A'] = {
                                id: attachment.id,
                                name: attachment.name,
                                code: attachment.code,
                                title: attachment.name,
                                custom_name: attachment.name
                            };

                            if (self.showBackCardUpload(attachment.code)) {
                                self.backCardAttachments = self.backCardAttachments || {attachment: {code: getBackCardCode(attachment.code)}, selectedFile: {}}
                            }
                        }

                    } else if (attachment.list_type === 'B') {
                        self.listType = 'LIST_B_AND_C';
                        self.data.userAttachments.push(attachment);
                        self.selectedFiles['B'] = {
                            id: attachment.id,
                            name: attachment.name,
                            code: attachment.code,
                            title: attachment.name,
                            custom_name: attachment.name
                        };
                    } else if (attachment.list_type === 'C') {
                        self.listType = 'LIST_B_AND_C';
                        self.data.userAttachments.push(attachment);

                        self.selectedFiles['C'] = {
                            id: attachment.id,
                            name: attachment.name,
                            code: attachment.code,
                            title: attachment.name,
                            custom_name: attachment.name
                        };
                    } else if (attachment.list_type === 'A_SECOND') {
                        self.listType = 'LIST_A';
                        isThereSecondA = true;
                        if (A_OTHER_ATTACHMENT[LIST_A_CODE]) {
                            self.listDocs['A_SECOND'] = A_OTHER_ATTACHMENT[LIST_A_CODE].SECOND_ATTACHMENT;
                            self.data.userAttachments.push(attachment);

                            self.selectedFiles['A_SECOND'] = {
                                id: attachment.id,
                                name: attachment.name,
                                code: attachment.code,
                                title: attachment.name,
                                custom_name: attachment.name
                            };
                        }
                    } else if (attachment.list_type === 'A_THIRD') {
                        self.listType = 'LIST_A';
                        isThereThirdA = true;

                        if (A_OTHER_ATTACHMENT[LIST_A_CODE]) {
                            self.listDocs['A_THIRD'] = A_OTHER_ATTACHMENT[LIST_A_CODE].THIRD_ATTACHMENT;
                            self.data.userAttachments.push(attachment);

                            self.selectedFiles['A_THIRD'] = {
                                id: attachment.id,
                                name: attachment.name,
                                code: attachment.code,
                                title: attachment.name,
                                custom_name: attachment.name
                            };
                        }
                    }

                    if (!BACK_CARD_ATTACHMENTS[attachment.code]) {
                        self.getIssuingAuth(attachment.code);
                    }
                }

                if (!isThereSecondA && self.listType === 'LIST_A') {
                    if (A_OTHER_ATTACHMENT[LIST_A_CODE]) {
                        self.listDocs['A_SECOND'] = A_OTHER_ATTACHMENT[LIST_A_CODE].SECOND_ATTACHMENT;

                        self.data.userAttachments.push({
                            'list_type': 'A_SECOND'
                        });
                    }
                }

                if (!isThereThirdA && self.listType === 'LIST_A') {

                    if (A_OTHER_ATTACHMENT[LIST_A_CODE]) {
                        self.listDocs['A_THIRD'] = A_OTHER_ATTACHMENT[LIST_A_CODE].THIRD_ATTACHMENT;

                        self.data.userAttachments.push({
                            'list_type': 'A_THIRD',
                            'title': 'N/A',
                            'code': 'N/A',
                            'name': 'N/A',
                            'custom_name': 'N/A',
                            'attachment_code_lookup': {}
                        });
                    }
                }
            } else {
                self.data.userAttachments = [
                    {
                        list_type: 'A'
                    }
                ];
                self.listType = 'LIST_A';
                self.changeDocumentList('B');
            }

            self.ssnApplied = self.OBIdObj.document.meta_data.personal_information.ssn_applied;
            var SSNI9 = self.OBIdObj.document.meta_data.personal_information.ssn || "";
            var birthdate = self.OBIdObj.document.meta_data.personal_information.birthdate;
            self.isMinorEmployee = (
                birthdate &&
                moment(birthdate).isValid() &&
                moment().diff(moment(birthdate), 'years') < 18
            );

            var checkSSNI9Warnings = function (ssn) {

                var formatedSSN = ssn.match(/\d*/g)
                    .join('')
                    .match(/(\d{0,3})(\d{0,2})(\d{0,4})/).slice(1).join('-')
                    .replace(/-*$/g, '');
                var ssnArray = formatedSSN.split('-');


                var SSNRegexFirst3 = new RegExp('^(?!000)(?!666)(?!9)\\d{3}$');
                var SSNRegexMiddle2 = new RegExp('^(?!00)\\d{2}$');
                var SSNRegexLast4 = new RegExp('^(?!0000)\\d{4}$');

                if (ssnArray.length) {

                    if (!SSNRegexFirst3.test(ssnArray[0])) {
                        self.first3DigitsWarning = true;
                        self.invalidFirst3Digits = ssnArray[0];
                    } else {
                        self.first3DigitsWarning = false;
                        delete self.invalidFirst3Digits;
                    }

                    if (!SSNRegexMiddle2.test(ssnArray[1])) {
                        self.middle2DigitsWarning = true;
                        self.invalidMiddle2Digits = ssnArray[1];
                    } else {
                        self.middle2DigitsWarning = false;
                        delete self.invalidMiddle2Digits;
                    }

                    if (!SSNRegexLast4.test(ssnArray[2])) {
                        self.last4digitsWarning = true;
                        self.invalidLast4Digits = ssnArray[2];
                    } else {
                        self.last4digitsWarning = false;
                        delete self.invalidLast4Digits;
                    }
                }
            };

            var removeSSNI9Warnings = function () {
                self.first3DigitsWarning = false;
                delete self.invalidFirst3Digits;
                self.middle2DigitsWarning = false;
                delete self.invalidMiddle2Digits;
                self.last4digitsWarning = false;
                delete self.invalidLast4Digits;
            }

            if (SSNI9) {
                checkSSNI9Warnings(SSNI9);
            } else {
                removeSSNI9Warnings();
            }

            if (self.employerPreFillingEnabled) {

                //put the current position for loggedInUser
                getUserCurrentPositionWithCache(user.data.user.id)
                    .then(function (res) {
                        self.data.title_of_employer = res.current_position;
                    });
            }

            getLastDocMetaWithCache(OnBoardingAPI.DOCUMENT_TYPE.I9, self.OBIdObj.document.document_set_code, self.OBIdObj.brand.id)
                .then(function (res) {
                    if (res) {
                        var docsSettings = {
                            default_fields: {},
                            locations: {}
                        };

                        if (res.default_fields_settings) {
                            docsSettings = documentsDefaultFieldsService.parseDocsDefaultFieldsSettings(res.default_fields_settings);
                        }
                        self.data.business_name = docsSettings.default_fields.LEGAL_ENTITY_NAME || res.business_name || self.data.business_name;

                        res.business_address = res.business_address || {};
                        self.data.business_address = self.data.business_address || {};
                        self.data.business_address.address = res.business_address.address;
                        self.data.business_address.street = docsSettings.locations.PHYSICAL && docsSettings.locations.PHYSICAL.address_line_1 || res.business_address.street;
                        self.data.business_address.city = docsSettings.locations.PHYSICAL && docsSettings.locations.PHYSICAL.city || res.business_address.city || self.data.business_address.city;
                        self.data.business_address.state = (docsSettings.locations.PHYSICAL && docsSettings.locations.PHYSICAL.state && docsSettings.locations.PHYSICAL.state.code) || res.business_address.state || self.data.business_address.state;
                        self.data.business_address.state = convertBetweenStateAndAbbreviation(self.data.business_address.state, true);
                        self.data.business_address.zip_code = docsSettings.locations.PHYSICAL && docsSettings.locations.PHYSICAL.postal_code || res.business_address.zip_code || self.data.business_address.zip_code;

                        if (self.employerPreFillingEnabled) {
                            self.data.employer_first_name = self.data.employer_first_name || res.employer_first_name;
                            self.data.employer_last_name = self.data.employer_last_name || res.employer_last_name;
                            self.data.title_of_employer = self.data.title_of_employer || res.title_of_employer;
                        }
                    }
                });

            setTimeout(function () {
                $scope.$digest();
            }, 1);

        }
    };


    //Select file to upload new attachments
    self.onFileSelected = function(files, list, docCode) {
        if (files && files[0]) {

            var fileType = Utils.getFileType(files[0]);

            if (fileType.indexOf("image/") > -1 || fileType.indexOf("/pdf") > -1) {

                if (BACK_CARD_ATTACHMENTS[docCode]) {
                    if(self.backCardAttachments && self.backCardAttachments.selectedFile && self.backCardAttachments.selectedFile.id) {
                        hConfirm({
                            title: "Overwrite Document",
                            text: "Are you sure you want to replace the file uploaded by the employee?",
                            confirmButton: "Yes",
                            cancelButton: "No",
                            callback: function (confirmed) {

                                if (confirmed) {
                                    self.backCardAttachments.selectedFile = self.backCardAttachments.selectedFile || {};
                                    self.backCardAttachments.selectedFile.file = files[0];
                                    self.backCardAttachments.selectedFile.progress = 100;
                                    self.backCardAttachments.selectedFile.list = list;
                                    self.backCardAttachments.selectedFile.id = self.backCardAttachments.attachment.id;
                                    self.backCardAttachments.selectedFile.name = self.documentTitles[self.backCardAttachments.attachment.code];
                                    self.backCardAttachments.selectedFile.code = self.backCardAttachments.attachment.code;
                                    self.backCardAttachments.selectedFile.custom_name = self.documentTitles[self.backCardAttachments.attachment.code];
                                    self.backCardAttachments.selectedFile.title = self.documentTitles[self.backCardAttachments.attachment.code];
                                }

                                setTimeout(function () {
                                    $scope.$digest();
                                }, 1);

                            }
                        });
                    } else {
                        self.backCardAttachments.selectedFile = self.backCardAttachments.selectedFile || {};
                        self.backCardAttachments.selectedFile.file = files[0];
                        self.backCardAttachments.selectedFile.progress = 100;
                        self.backCardAttachments.selectedFile.list = list;
                        self.backCardAttachments.selectedFile.code = docCode;
                        self.backCardAttachments.selectedFile.name =  self.documentTitles[docCode];
                        self.backCardAttachments.selectedFile.title =  self.documentTitles[docCode];
                        self.backCardAttachments.selectedFile.custom_name =  self.documentTitles[docCode];
                    }
                } else {
                    var attachment = findAttachment(self.data.userAttachments, list);

                    if(attachment && attachment.id) {
                        hConfirm({
                            title: "Overwrite Document",
                            text: "Are you sure you want to replace the file uploaded by the employee?",
                            confirmButton: "Yes",
                            cancelButton: "No",
                            callback: function (confirmed) {

                                if (confirmed) {
                                    self.selectedFiles[list] = self.selectedFiles[list] || {};
                                    self.selectedFiles[list].file = files[0];
                                    self.selectedFiles[list].progress = 100;
                                    self.selectedFiles[list].list = list;
                                    self.selectedFiles[list].id = attachment.id;
                                    self.selectedFiles[list].code = attachment.code;
                                    self.selectedFiles[list].name = self.documentTitles[attachment.code];
                                    self.selectedFiles[list].custom_name = self.documentTitles[attachment.code];
                                    self.selectedFiles[list].title = self.documentTitles[attachment.code];
                                }

                                setTimeout(function () {
                                    $scope.$digest();
                                }, 1);

                            }
                        });
                    } else {
                        self.selectedFiles[list] = self.selectedFiles[list] || {};
                        self.selectedFiles[list].file = files[0];
                        self.selectedFiles[list].progress = 100;
                        self.selectedFiles[list].list = list;
                        self.selectedFiles[list].code = docCode;
                        self.selectedFiles[list].name = self.documentTitles[docCode];
                        self.selectedFiles[list].title = self.documentTitles[docCode];
                        self.selectedFiles[list].custom_name = self.documentTitles[docCode];
                    }
                }
            }
            else {
                hAlert("Invalid Attachment", "Attachment document should be image or PDF file.");
            }
        }
    };

    self.unselectFile = function(listId, isBackCardAttachment) {
        if (isBackCardAttachment) {
            delete self.backCardAttachments.selectedFile.file;
        } else {
            delete self.selectedFiles[listId].file;
        }
    };


    // Upload the attachments
    // Please, please, please don't change this before make sure e-verify still working :)
    var uploadAttachment = function (file, OBIdObj) {
        var defer = $q.defer();

        OBIdObj = OBIdObj || self.OBIdObj;

        var uploadUrl = file.id ? `${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment/${file.id}` : `${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment`;
        var uploadMethod = file.id ? 'POST' : 'PUT';

        var attachmentCode = OnBoardingAPI.attachmentCodeLookup[file.code] || {};

        var data = {
            document_id: OBIdObj.document.id,
            custom_name:  OnBoardingAPI.DOCUMENT_CODES_TITLES[file.code] || attachmentCode.name || file.name,
            attachment_file: file.file,
            list_type: file.list
        };

        if (attachmentCode.id) {
            data['attachment_code_lookup_id'] = attachmentCode.id;
        }

        Upload.upload({
            url: uploadUrl,
            withCredentials: true,
            headers: {},
            method: uploadMethod,
            data: data
        }).progress(function (evt) {
            var uploaded = evt.loaded || 0;
            var total = evt.total;
            file.progress = 100 * uploaded / total;
        }).success(function (data, status, headers, config) {

            if (data.status_code == 200) {
                defer.resolve(data);
            }
            else {
                defer.reject(data);
            }

        }).error(function (reason) {
            defer.reject(data);
        });

        return defer.promise;
    };

    // upload employer attachments from outside
    self.uploadAttachment = uploadAttachment;

    self.prepareMetaData = function () {
        //metaData to be saved is same as form data
        var metaData = angular.copy(self.data);
        //re-format some data
        metaData.userAttachments = _.indexBy(metaData.userAttachments, 'list_type');
        metaData.employee_first_day = new Date(metaData.employee_first_day);
        metaData.employee_first_day.setHours(12);
        metaData.employee_first_day = metaData.employee_first_day.toISOString();

        metaData.examination_date = new Date(metaData.examination_date);
        metaData.examination_date.setHours(12);
        metaData.examination_date = metaData.examination_date.toISOString();
        metaData.employer_is_alternative_procedure_used = metaData.employer_is_alternative_procedure_used_boolean_value? 'YES':'NO';
        return metaData;
    };

    var candidateDocActionCall = function() {
        var defer = $q.defer();
        var metaData = self.prepareMetaData();

        OnBoardingAPI.candidateDocAction(self.OBIdObj.document.id, OnBoardingAPI.appStatuses.APPROVED, metaData)
            .then(function(res) {
                    defer.resolve(res);
                },
                function(err){
                    defer.reject(err);
                });

        return defer.promise;

    };

    self.prepareAttachmentsPromises = function () {
        var promises = [];

        if(self.listType == 'LIST_A') {
            if (self.selectedFiles['A']) {
                promises.push(uploadAttachment(self.selectedFiles['A']));

                if (
                    self.backCardAttachments &&
                    self.backCardAttachments.selectedFile &&
                    self.showBackCardUpload(self.selectedFiles['A'].code)
                ) {
                    promises.push(uploadAttachment(self.backCardAttachments.selectedFile));
                }

            } else {
                var docA = findAttachment(self.data.userAttachments, 'A') || {};

                if (Object.keys(docA).length && docA.attachment_code_lookup) {
                    if (
                        self.backCardAttachments &&
                        self.backCardAttachments.selectedFile &&
                        self.showBackCardUpload(docA.code || docA.attachment_code_lookup.code)
                    ) {
                        promises.push(uploadAttachment(self.backCardAttachments.selectedFile));
                    }
                }
            }
        }

        if(self.selectedFiles['A_SECOND'] && self.listType == 'LIST_A') {
            promises.push(uploadAttachment(self.selectedFiles['A_SECOND']));
        }

        if(self.selectedFiles['A_THIRD'] && self.listType == 'LIST_A') {
            promises.push(uploadAttachment(self.selectedFiles['A_THIRD']));
        }

        if(self.selectedFiles['B'] && self.listType == 'LIST_B_AND_C') {
            promises.push(uploadAttachment(self.selectedFiles['B']));
        }

        if(self.selectedFiles['C'] && self.listType == 'LIST_B_AND_C') {
            promises.push(uploadAttachment(self.selectedFiles['C']));
        }

        return promises;
    };

    self.checkIfAllowedToSave = function () {
        var defer = $q.defer();
        //validate the attachments are there
        var checkAttachments = function () {

            var isAllowedToSave = false;

            if (self.listType == 'LIST_A') {
                var aDocs = self.selectedFiles['A'] || {};

                if (aDocs && A_OTHER_ATTACHMENT[aDocs.code]) {
                    var aSecondAttachment = findAttachment(self.data.userAttachments, 'A_SECOND') || {};
                    var AOtherAttachments = A_OTHER_ATTACHMENT[aDocs.code];

                    if (
                        AOtherAttachments.SECOND_ATTACHMENT.length &&
                        (
                            (self.selectedFiles['A_SECOND'] && self.selectedFiles['A_SECOND'].file) ||
                            (!_.isEmpty(aSecondAttachment) && (aSecondAttachment.s3_path || aSecondAttachment.signed_url))
                        )
                    ) {
                        if (AOtherAttachments.THIRD_ATTACHMENT.length) {
                            var aThirdDocs = findAttachment(self.data.userAttachments, 'A_THIRD') || {};

                            if (
                                (self.selectedFiles['A_THIRD'] && self.selectedFiles['A_THIRD'].file) ||
                                (!_.isEmpty(aThirdDocs) && (aThirdDocs.s3_path || aThirdDocs.signed_url)) ||
                                aThirdDocs.code == "N/A"
                            ) {
                                isAllowedToSave = true;
                            }
                        } else {
                            isAllowedToSave = true;
                        }
                    }
                } else if (aDocs.id || aDocs.file) {
                    if (self.showBackCardUpload(aDocs.code)) {
                        isAllowedToSave = (
                            self.backCardAttachments &&
                            !!(
                                self.backCardAttachments.selectedFile &&
                                (self.backCardAttachments.selectedFile.id || self.backCardAttachments.selectedFile.file) ||
                                findBackAttachment((self.OBIdObj.document && self.OBIdObj.document.attachments || []), self.backCardAttachments.attachment.code)
                            )
                        );
                    } else {
                        isAllowedToSave = true;
                    }
                }
            } else {
                var bDoc = self.selectedFiles['B'];
                var cDoc = self.selectedFiles['C'];

                isAllowedToSave = bDoc &&
                    (bDoc.id || bDoc.file) &&
                    cDoc &&
                    (cDoc.id || cDoc.file);
            }

            if(isAllowedToSave || self.OBIdObj.document.employer_exclude_attachments) {
                defer.resolve();
            } else {
                hAlert(
                    "Attachments are required",
                    "Attachments are missing. You should upload attachments"
                );
                defer.reject();
            }
        };


        // Check if more than 3 days before
        var checkEmploymentDate = function () {
            var firstDayOfEmployment = new Date(self.data.employee_first_day);
            if ( (Date.now() - firstDayOfEmployment.getTime()) >= 3 * 24 * 60 * 60 * 1000 ) {
                var confirmOptions = {
                    confirmButton: 'Continue and Sign',
                    cancelButton: 'Cancel',
                    text: "More than 3 days have passed since the selected employee's first day of employment, Are you sure you want to continue with signing this I-9?",
                    callback: function(confirmed) {
                        if (confirmed) {
                            setTimeout(function() {
                                checkAttachments();
                            }, 500);
                        } else {
                            defer.reject();
                        }
                    }
                };

                hConfirm(confirmOptions);
            }
            else {
                checkAttachments();
            }
        };

        checkEmploymentDate();
        return defer.promise;
    };

    //saving the form
    self.save = function (showError, sendWithoutSuccessCallback) {
        var defer = $q.defer();

        if (self.validator.validate()) {

            var save = function() {
                //disable save
                self.saving = true;
                var promises = [];

                if (!self.OBIdObj.document.employer_exclude_attachments) {
                    promises = self.prepareAttachmentsPromises();
                }

                $q.all(promises).then(function (res) {

                    //hide verfiy modal if shown
                    $("#verify-account-modal").modal("hide");

                    candidateDocActionCall()
                        .then(function (resDoc) {
                            self.saving = false;

                            defer.resolve(resDoc);

                            if (!sendWithoutSuccessCallback) {
                                //trigger after save event
                                trigger("esigned", res);
                            }

                            setTimeout(function () {
                                $scope.$digest();
                            }, 1);
                        }, function (err) {
                            console.error(err);
                            self.saving = false;

                            defer.reject(err);

                            if (showError) {
                                $scope.saveSecondPhaseErr = "email";
                            }

                            if (err.status === 412) {
                                self.data.verification_email = err.data.data.verification_email;
                                $("#verify-account-modal").modal("show");
                            }
                            else if (err.data.status_code === 400 && err.data.data.code === 'EMAIL_PHONE_NOT_VERIFIED') {
                                var errMessage = $filter("translate")("Email and Phone are not verified");
                                hAlert("Error!", errMessage);
                            }
                            else if (err.data && err.data.data) {
                                hAlert("Error!", err.data.data);
                            }

                            setTimeout(function () {
                                $scope.$digest();
                            }, 1);
                        });
                }, function (err) {
                    self.saving = false;

                    if (showError) {
                        $scope.saveSecondPhaseErr = "email";
                    }

                    if (err.status === 412) {
                        self.data.verification_email = err.data.data.verification_email;
                        $("#verify-account-modal").modal("show");
                    }
                    else if (err.data && err.data.data) {
                        hAlert("Error!", err.data.data);
                    }
                    else {
                        console.error(err);
                    }


                    setTimeout(function () {
                        $scope.$digest();
                    }, 1);

                });
            };

            self.checkIfAllowedToSave()
                .then(function () {
                    save();
                });
        } else {

            setTimeout(function(){
                $("html, body").scrollTop($('.' + formName + ' .error').first().offset().top - 300);
            }, 100);
        }

        return defer.promise;
    };

    var alphaeticsSpacesSingleQuotesOnly = function(value){
        var regex = new RegExp(/^[a-zA-Z'’\- ]*$/);

        if (value && !regex.test(value)) {
            return false;
        }
        return true;
    };

    self.onFirstNameChanged = function(value){
        if (!value) {
            self.warning.first_name = {};
        } else {
            self.warning.first_name = self.warning.first_name || {};
            self.warning.first_name['specialPattern'] = !alphaeticsSpacesSingleQuotesOnly(value);
        }
    };

    self.onLastNameChanged = function(value){
        if (!value) {
            self.warning.last_name = {};
        } else {
            self.warning.last_name = self.warning.last_name || {};
            self.warning.last_name['specialPattern'] = !alphaeticsSpacesSingleQuotesOnly(value);
        }
    };

    self.validator.validateCustom = function(field, optionsField, rule, showError) {

        var value = self.validator.getFieldValue(field);
        switch (rule.name) {

            case "requiredIfDocument":
                if (self.docsDateValidation[rule.params[0]].required && !value) {
                    return false;
                }
                break;
        }

        return true;
    };

    //Find a document
    var findAttachment = function (list, key) {
        var attachment = _.find(list, function(element) {
            return !BACK_CARD_ATTACHMENTS[element.code] && element.list_type === key && (element.signed_url || self.selectedFiles[key] || element == 'N/A' || element.code == 'N/A');
        });

        return attachment;
    };

    var findBackAttachment = function (list, code) {
        var attachment = _.find(list, function(element) {
            return (
                element.list_type === 'A' &&
                element.attachment_code_lookup &&
                element.attachment_code_lookup.code === code &&
                (element.signed_url || self.backCardAttachments && self.backCardAttachments.selectedFile)
            );
        });

        return attachment;
    };

    self.getIssuingAuth = function (attachmentCode) {

        var attachment = self.data.userAttachments.find(function (attach) {
            return attach.code === attachmentCode
        });

        var code = attachmentCode;

        setTimeout(function () {
            for (var i in DOC_ISSUING_AUTH) {
                if (DOC_ISSUING_AUTH[i].docs.indexOf(code) > -1) {
                    if (DOC_ISSUING_AUTH[i].issuings.length === 1) {
                        attachment.issuing_authority = DOC_ISSUING_AUTH[i].issuings[0].Code;
                        attachment.issuing_authority_name = DOC_ISSUING_AUTH[i].issuings[0].Name;
                    }
                    else if (DOC_ISSUING_AUTH[i].issuings.indexOf(attachment.issuing_authority) === -1) {
                        attachment.issuing_authority = "";
                        attachment.issuing_authority_name = "";
                    }

                    self.attachmentIssuers[attachment.code] = DOC_ISSUING_AUTH[i].issuings;
                    attachment.issuing_authority_type = DOC_ISSUING_AUTH[i].issuing_authority_type;
                    break;
                }
            }
            $scope.$digest();
        }, 100);
    };

    self.fixImagePos = function (event) {

        if ($(document).width() <= 640) {
            $img.css('bottom', '');
            $img.css('top', 75);
            return;
        }

        var imageOffsetValue = 20;

        var $img = $(event.currentTarget.firstElementChild);

        $img.css('bottom', imageOffsetValue);
        $img.css('top', '');

        var imgTopPos = $img.offset().top;
        var windowTopPos = $(window).scrollTop() + 75;

        if (imgTopPos < windowTopPos) {
            $img.css('top', imageOffsetValue);
            $img.css('bottom', '');
        } else {
            $img.css('bottom', imageOffsetValue);
            $img.css('top', '');
        }

    };

};
